import { api } from '@/lib/api/client';
import { createTeamApi, getTeamApi, getTeamsApi } from '@api-client/teams';

export { getTeamsApi, getTeamApi, createTeamApi };
export type { CreateTeamPayload, GetTeamsParams, Team } from '@api-client/teams';

export async function createCheckoutSessionApi(
  teamId: number,
  successUrl: string,
  cancelUrl: string,
): Promise<{ checkoutUrl: string }> {
  return api.post(`/teams/${teamId}/checkout-session`, { successUrl, cancelUrl });
}

export interface LicenseAvailabilityResponse {
  available: boolean;
  usedBy?: { playerName: string; teamName: string };
}

export async function checkLicenseAvailabilityApi(
  competitionId: number,
  licenseNumber: string,
): Promise<LicenseAvailabilityResponse> {
  return api.get(
    `/teams/check-license-availability?competitionId=${competitionId}&licenseNumber=${encodeURIComponent(licenseNumber)}`,
  );
}

export interface TeamNameAvailabilityResponse {
  available: boolean;
}

export async function checkTeamNameAvailabilityApi(
  competitionId: number,
  name: string,
): Promise<TeamNameAvailabilityResponse> {
  return api.get(`/teams/check-name-availability?competitionId=${competitionId}&name=${encodeURIComponent(name)}`);
}
